export default __webpack_public_path__ + "static/media/block-services-1.6374b672.webp";